import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ServerConstants} from '../../../model/ServerConstants';
import {ValueFromAdditionalMapPipe} from '../../../pipes/value-from-additional-map.pipe';
import {UtilService} from '../../../util/util.service';
import {TopLevelDomainVO} from '../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../generate/ChangeVO';


@Component({
  selector: 'sub-domain-info',
  templateUrl: './sub-domain-info.component.html',
  styleUrls: ['./sub-domain-info.component.scss']
})
export class SubDomainInfoComponent implements OnInit {

  @Input()
  domain: TopLevelDomainVO;
  @Input()
  registryURLChange: ChangeVO;
  @Input()
  whoIsChange: ChangeVO;
  @Input()
  rdapServerChange: ChangeVO;
  editmode: boolean;
  @Input()
  hideEdit: boolean;
  showEdit: boolean;
  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomainVO>();
  @Input()
  viewMode: boolean;

  constructor(private util: UtilService) {
  }

  ngOnInit() {
    if (this.hideEdit) {
      this.showEdit = false;
    } else {
      this.showEdit = this.checkIfAllFieldsAreLocked();
    }
  }

  edit(val) {
    this.editmode = val;
  }

  cancel(val) {
    this.edit(false);
  }

  domainOutPut(domain: TopLevelDomainVO) {
    this.modifiedTLDOutput.emit(domain);
    this.edit(false);
  }

  checkIfAllFieldsAreLocked(): boolean {
    return this.util.checkIfEmptyList(this.getPendingRequestChangeID(ServerConstants.REGISTRYURL_FIELD_NAME))
      || this.util.checkIfEmptyList(this.getPendingRequestChangeID(ServerConstants.WHOIS_FIELD_NAME))
      || this.util.checkIfEmptyList(this.getPendingRequestChangeID(ServerConstants.RDAP_SERVER_FIELD_NAME));
  }


  getPendingRequestChangeID(type: string): string[] {
    return new ValueFromAdditionalMapPipe().transform(this.domain, ServerConstants.LOCK_FIELD_NAME, type);
  }

}
